import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginDataModel } from "../../models/Reducer.model";
import { ActionModel } from "../../models/General.model";
import { LANGUAGES } from "../../utils/constants/Constants";
import { get } from "http";
import { stat } from "fs";
import { error } from "console";

const initialState = {
   isApiLoading: false,
   error: null,
   applicationNames: []
  };

const GeneralSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        setLoader(state, action: PayloadAction<any>) {
            console.log(action);
            state.isApiLoading = action.payload;
        },
        setError(state, action: PayloadAction<ActionModel>) {
            console.log(action);
            // const { error } = action.payload;
            // state.error = error;
        },
        setApplicationDetails(state, action: PayloadAction<any>) {
            //console.log("yess", action.payload.value);
            state.applicationNames = action.payload.value;
        },
        getApplicationDetails(state) {
            state.applicationNames = [];
        }
    }
});

export const {
    setLoader,
    getApplicationDetails,
    setApplicationDetails
} = GeneralSlice.actions;

export default GeneralSlice.reducer;